import { render, staticRenderFns } from "./BMHCDetail.vue?vue&type=template&id=0c50bdb2&scoped=true"
import script from "./BMHCDetail.vue?vue&type=script&lang=js"
export * from "./BMHCDetail.vue?vue&type=script&lang=js"
import style0 from "./BMHCDetail.vue?vue&type=style&index=0&id=0c50bdb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50bdb2",
  null
  
)

export default component.exports